// /home/szymon/kreator2/frontend/src/components/StatusesPanel.js
// v1.0.0 – Panel do zarządzania listą statusów (ADMIN)

import React, { useState, useEffect } from "react";

export default function StatusesPanel({ backendUrl }) {
  const [statuses, setStatuses] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Dodawanie/edycja
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [nameValue, setNameValue] = useState("");
  const [mailTriggerId, setMailTriggerId] = useState("");

  // 1) Pobieranie listy statusów
  const fetchStatuses = async () => {
    try {
      setLoading(true);
      setError("");
      const res = await fetch(`${backendUrl}/admin/statuses`, {
        credentials: "include",
      });
      if (!res.ok) {
        throw new Error("Błąd pobierania listy statusów.");
      }
      const data = await res.json();
      setStatuses(data);
    } catch (err) {
      console.error("[StatusesPanel] fetchStatuses =>", err);
      setError("Nie udało się pobrać statusów z serwera.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatuses();
    // eslint-disable-next-line
  }, []);

  // 2) Obsługa kliknięcia "Dodaj nowy"
  const handleAddClick = () => {
    setShowForm(true);
    setEditId(null);
    setNameValue("");
    setMailTriggerId("");
  };

  // 3) Obsługa zapisu
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const body = {
        name: nameValue,
        mailTriggerId: mailTriggerId ? Number(mailTriggerId) : null,
      };
      let url = `${backendUrl}/admin/statuses`;
      let method = "POST";
      if (editId) {
        url = `${backendUrl}/admin/statuses/${editId}`;
        method = "PUT";
      }
      const res = await fetch(url, {
        method,
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        throw new Error("Błąd zapisu statusu.");
      }
      await res.json();
      setShowForm(false);
      fetchStatuses();
    } catch (err) {
      console.error("[handleSubmit] =>", err);
      setError("Nie udało się zapisać statusu.");
    } finally {
      setLoading(false);
    }
  };

  // 4) Edycja istniejącego
  const handleEdit = async (id) => {
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${backendUrl}/admin/statuses/${id}`, {
        credentials: "include",
      });
      if (!res.ok) {
        throw new Error("Błąd pobierania statusu do edycji.");
      }
      const data = await res.json();
      setShowForm(true);
      setEditId(data.id);
      setNameValue(data.name);
      setMailTriggerId(data.mailTriggerId || "");
    } catch (err) {
      console.error("[handleEdit] =>", err);
      setError("Nie udało się pobrać statusu do edycji.");
    } finally {
      setLoading(false);
    }
  };

  // 5) Usuwanie
  const handleDelete = async (id) => {
    if (!window.confirm("Na pewno usunąć status?")) return;
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${backendUrl}/admin/statuses/${id}`, {
        method: "DELETE",
        credentials: "include",
      });
      if (!res.ok) {
        throw new Error("Błąd usuwania statusu.");
      }
      await res.json();
      fetchStatuses();
    } catch (err) {
      console.error("[handleDelete] =>", err);
      setError("Nie udało się usunąć statusu.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="orders-container" style={{ marginTop: 20 }}>
      <h3>Lista Statusów</h3>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading && <p style={{ color: "#999" }}>Przetwarzanie...</p>}

      <button className="orders-add-btn" onClick={handleAddClick}>
        {showForm ? "Anuluj" : "Dodaj Status"}
      </button>

      {showForm && (
        <form onSubmit={handleSubmit} className="orders-add-form" style={{ marginTop: 10 }}>
          <div className="orders-form-group">
            <label>Nazwa:</label>
            <input
              type="text"
              value={nameValue}
              onChange={(e) => setNameValue(e.target.value)}
              className="orders-input"
            />
          </div>
          <div className="orders-form-group">
            <label>MailTriggerID:</label>
            <input
              type="number"
              value={mailTriggerId}
              onChange={(e) => setMailTriggerId(e.target.value)}
              className="orders-input"
            />
          </div>
          <button className="orders-button" type="submit">
            Zapisz
          </button>
        </form>
      )}

      <table className="orders-table" style={{ marginTop: 15 }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nazwa</th>
            <th>TriggerID</th>
            <th>Akcje</th>
          </tr>
        </thead>
        <tbody>
          {statuses.length === 0 ? (
            <tr>
              <td colSpan={4} style={{ textAlign: "center" }}>
                Brak statusów w bazie.
              </td>
            </tr>
          ) : (
            statuses.map((st) => (
              <tr key={st.id}>
                <td>{st.id}</td>
                <td>{st.name}</td>
                <td>{st.mailTriggerId || "-"}</td>
                <td>
                  <button
                    style={{
                      marginRight: 8,
                      padding: "6px 12px",
                      cursor: "pointer",
                      backgroundColor: "#eee",
                      borderRadius: 4,
                      border: "1px solid #ccc",
                    }}
                    onClick={() => handleEdit(st.id)}
                  >
                    Edytuj
                  </button>
                  <button
                    onClick={() => handleDelete(st.id)}
                    style={{
                      padding: "6px 12px",
                      cursor: "pointer",
                      backgroundColor: "#d9534f",
                      color: "#fff",
                      border: "none",
                      borderRadius: 4,
                    }}
                  >
                    Usuń
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
